import { Box, Heading } from "@chakra-ui/react";
import { Team } from "common";
import { useNavigate } from "react-router-dom";
import { Avatar } from "../avatar/Avatar";
import { Card } from "../utils/Card";
import { TeamBanner } from "../utils/TeamBanner";
import { useGetTeamLeaders } from "./useGetTeamLeaders";

interface TeamCardProps {
  team: Team;
  clickable?: boolean;
}

export const TeamCard = ({ team, clickable = true }: TeamCardProps) => {
  const navigate = useNavigate();
  const teamLeaders = useGetTeamLeaders({ team });
  return (
    <Card
      display={"flex"}
      alignItems={"center"}
      marginBottom={4}
      paddingTop={0}
      paddingLeft={4}
      paddingRight={4}
      cursor={clickable ? "pointer" : undefined}
      onClick={clickable ? () => navigate(`/team/${team.id}`) : undefined}
      width={"100%"}
    >
      <TeamBanner
        padding={2}
        color={team.color}
        iconType={team.iconType}
        iconColor={team.iconColor}
        width={100}
      />
      <Box
        marginLeft={4}
        display={"flex"}
        flexDir={"column"}
        justifyContent={"center"}
        width={"100%"}
      >
        <Heading fontSize={"x-large"}>{team.name}</Heading>
        <Box>{team.points} points</Box>
      </Box>
      <Box display={"flex"} width={"100%"} justifyContent={"flex-end"}>
        {teamLeaders.map((account) => (
          <Box
            key={account.id}
            marginLeft={2}
            display={"flex"}
            flexDir={"column"}
            alignItems={"center"}
            justifyContent={"center"}
          >
            <Avatar
              config={account.avatarConfig}
              round={true}
              width={"40"}
              height={"40"}
            />
            <Box fontSize={"small"} opacity={"0.8"}>
              {account.fName}
            </Box>
          </Box>
        ))}
      </Box>
    </Card>
  );
};
